function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4041(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 294.77,
    cy: 382.08,
    r: 35.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.15,342.28c-22.26,0-35.64-19.75-40.39-37.12l-.16-.61a6.54,6.54,0,1,1,12.65-3.29l.12.45c3.61,13.22,13.44,28.33,29.21,27.46a21.16,21.16,0,0,0,15.48-7.55c8.65-9.92,12.52-31.49,11.66-42.37a5.23,5.23,0,1,1,10.42-.83c1,12.11-.32,38.14-12.23,51.79a34.11,34.11,0,0,1-24.59,12C232.59,342.26,231.86,342.28,231.15,342.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.21,216.68s-9.71,28.12-4.48,50a42.77,42.77,0,0,0,24.39,29.11s-14.19,5-11,12.69,15.42,2.74,19.41.25,9-9.95,9.7-14.93a35.73,35.73,0,0,0,.5-7.71s16.17-1.74,27.12-10.7c0,0,9.71,7.71,16.68,6.22s16.92-13.94,15.92-25.13S307,245.3,303.06,247a16,16,0,0,0-5.48,3.48s5.72-7,0-16.67a21.75,21.75,0,0,0-15.93-10.45s-3-15.93-11.94-21.9S228.9,189.31,216.21,216.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.05,202.5s-10.45,14.68-11.94,29.61.25,24.88,4.73,28.62,8.95,2.24,11.44-1.25-1.49-15.68-1.49-15.68,4.23-11.69,10.7-19.9,7.71-9.46,7.71-9.46S206,201.75,196.05,202.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.9,195.25s11.84,13.58,14.79,28.3,2.2,24.79-1.9,28.94-8.69,3.11-11.51-.12,0-15.74,0-15.74-5.36-11.23-12.6-18.77-8.61-8.65-8.61-8.65S267.92,195.48,277.9,195.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.07,189.8s-3.08,10.39-1.92,14.62,6.54.39,11.93,5,10.38,12.93,30.79,14.47,32.73-9.47,37-15.63,3.85-13.47,11.16-13.85,1.16-14.63-1.15-16.94c0,0,14.24-21.17,14.24-26.56s-13.47-4.24-30,.77c0,0-12.32-6.55-34.65-2.7s-28.87,10.4-28.87,10.4-27.72,3.46-29.64,6.92S177.75,184.41,195.07,189.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 68.67,
    y1: 380.53,
    x2: 59.49,
    y2: 380.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.51,
    y1: 380.53,
    x2: 83.19,
    y2: 380.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--yarn-ball--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.07,
    cy: 410.55,
    rx: 30.39,
    ry: 8.36,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,429.54c-31.63,0-36.3-4.57-36.76-8.26a5,5,0,0,1,1.44-4.23c8.52-8.94,57.62-5.16,125.56.07,9.48.73,19.28,1.48,29.33,2.23,68.65,5.1,96.29,4.44,102-2.46,1.16-1.41,1.4-3.17.76-5.55-2.72-9.95-39.08-10-52.85-9.22a1.2,1.2,0,0,1-1.26-1.12,1.18,1.18,0,0,1,1.12-1.25c5.27-.31,51.57-2.64,55.28,11,.85,3.14.46,5.65-1.22,7.69-6.41,7.78-32.65,8.61-104,3.31-10.06-.75-19.86-1.5-29.34-2.23-64.76-5-115.92-8.93-123.66-.8a2.65,2.65,0,0,0-.8,2.29c.29,2.36,6,7.64,52,5.8,25.73-1,51.58-3.83,51.84-3.86a1.19,1.19,0,0,1,.26,2.36c-.26,0-26.19,2.84-52,3.87C160.06,429.42,154.18,429.54,149,429.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.77,
    cy: 382.08,
    r: 35.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.77,417.89a35.8,35.8,0,0,0,29.58-56c-.39,15.6-9,38.63-53.78,46.55A35.67,35.67,0,0,0,294.77,417.89Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.77,417.89a35.8,35.8,0,0,0,29.58-56c-.39,15.6-9,38.63-53.78,46.55A35.67,35.67,0,0,0,294.77,417.89Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.39,396.12a56.94,56.94,0,0,0-22.64-13.51,56.94,56.94,0,0,1,22.64,13.51l1.9,0a65.76,65.76,0,0,0,10.79-14.06C308.31,364.34,292,366.15,292,366.15s16.36-1.81,33.13,15.93c.92-1.65,1.69-3.2,2.32-4.63C320.47,367.67,308.45,361,302,360l-1.5-.36a21.24,21.24,0,0,0-7-.1,21.24,21.24,0,0,1,7,.1l4.27-12a35.8,35.8,0,0,0-6.17-1.19c-2.77,4.47-9.9,18.75-9.9,47.08,0-28.33,7.13-42.61,9.9-47.08-1.2-.11-2.4-.18-3.63-.18a36.1,36.1,0,0,0-4.05.24c-4.22,6.38-12.29,21.45-12.83,44.07C286.46,393.63,297.66,395.91,312.39,396.12Zm8.09-7.29c-14.26-13.9-30-14.63-30-14.63S306.22,374.93,320.48,388.83Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.05,390.64c.54-22.62,8.61-37.69,12.83-44.07a35.83,35.83,0,0,0-9.61,2.46,71.37,71.37,0,0,0-12.35,37.6A65.21,65.21,0,0,0,278.05,390.64Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.27,349a35.88,35.88,0,0,0-22.12,30.72,46.11,46.11,0,0,0,9.77,6.88A71.37,71.37,0,0,1,281.27,349Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.4,377.45a44.18,44.18,0,0,0,2-5.3,36,36,0,0,0-7.63-13.78L319,367.61l2.72-9.24a36,36,0,0,0-7.55-6.42l-3.05,11.41L314.19,352a35.45,35.45,0,0,0-9.46-4.25l-4.27,12C307,360.69,317.11,364.54,327.4,377.45Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.77,383.77c0-.52,0-1,0-1.56a35.87,35.87,0,0,0-1.44-10.06,44.18,44.18,0,0,1-2,5.3l0,0,0,0a22.69,22.69,0,0,1-1.52,3.06c.06.06-.86,1.51-.8,1.57s-1,1.8-1,1.74c-2.38,4.23-9.56,12.33-9.44,12.33-.12,0-3.88,3.41-5.93,5.13h0a98.79,98.79,0,0,1-11.89,8.45l.26,0-.26,0a124.09,124.09,0,0,1-12.69,6.7,36,36,0,0,0,10.81,1.66c.61,0,1.21,0,1.8,0C304,414.1,315.65,405,330.77,383.77Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.77,383.77C315.65,405,304,414.1,296.73,418A35.88,35.88,0,0,0,330.77,383.77Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.89,404.57a35.86,35.86,0,0,0,17.23,11.86,124.09,124.09,0,0,0,12.69-6.7C288.27,411.31,274.91,407.39,266.89,404.57Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.81,409.73a98.79,98.79,0,0,0,11.89-8.45c-25.79,2.64-41.7-5.35-48.46-9.89a35.76,35.76,0,0,0,6.65,13.18C274.91,407.39,288.27,411.31,296.81,409.73Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.7,401.28c2.05-1.72,3.9-3.44,5.59-5.14l-1.9,0c.14.13.28.26.41.4-.13-.14-.27-.27-.41-.4-14.73-.21-25.93-2.49-34.34-5.48v0c-12.29-4.26-16.72-8.84-18.9-10.89-.06.82-.1,1.63-.1,2.46a36.1,36.1,0,0,0,1.19,9.18C267,395.93,282.91,403.92,308.7,401.28Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 294.77,
    cy: 382.08,
    r: 35.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.15,342.28c-22.26,0-35.64-19.75-40.39-37.12l-.16-.61a6.54,6.54,0,1,1,12.65-3.29l.12.45c3.61,13.22,13.44,28.33,29.21,27.46a21.16,21.16,0,0,0,15.48-7.55c8.65-9.92,12.52-31.49,11.66-42.37a5.23,5.23,0,1,1,10.42-.83c1,12.11-.32,38.14-12.23,51.79a34.11,34.11,0,0,1-24.59,12C232.59,342.26,231.86,342.28,231.15,342.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.51,273.62a5.23,5.23,0,0,0-4.79,5.63c.42,5.31-.29,13.16-2.13,21a23.12,23.12,0,0,1,7.77,1,41.36,41.36,0,0,1-7.64,20.87c-9.71,13.49-24.27,17.8-35.6,16.18-5.07-.72-10.88-3.38-15.77-6.11a35.59,35.59,0,0,0,24.8,10.11c.71,0,1.44,0,2.17-.06a34.11,34.11,0,0,0,24.59-12c11.91-13.65,13.19-39.68,12.23-51.79A5.22,5.22,0,0,0,264.51,273.62Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.51,273.62a5.23,5.23,0,0,0-4.79,5.63c.42,5.31-.29,13.16-2.13,21a23.12,23.12,0,0,1,7.77,1,41.36,41.36,0,0,1-7.64,20.87c-9.71,13.49-24.27,17.8-35.6,16.18-5.07-.72-10.88-3.38-15.77-6.11a35.59,35.59,0,0,0,24.8,10.11c.71,0,1.44,0,2.17-.06a34.11,34.11,0,0,0,24.59-12c11.91-13.65,13.19-39.68,12.23-51.79A5.22,5.22,0,0,0,264.51,273.62Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.15,342.28c-22.26,0-35.64-19.75-40.39-37.12l-.16-.61a6.54,6.54,0,1,1,12.65-3.29l.12.45c3.61,13.22,13.44,28.33,29.21,27.46a21.16,21.16,0,0,0,15.48-7.55c8.65-9.92,12.52-31.49,11.66-42.37a5.23,5.23,0,1,1,10.42-.83c1,12.11-.32,38.14-12.23,51.79a34.11,34.11,0,0,1-24.59,12C232.59,342.26,231.86,342.28,231.15,342.28Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.31,328.75c.53-2.45-5.33,1.38-10.24,4.95a38.34,38.34,0,0,0,5.84,4.07C215.66,334.92,217.8,331.11,218.31,328.75Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.15,342.28c.71,0,1.44,0,2.17-.06a37.91,37.91,0,0,0,6.31-.89c-2.76-3.6-6.56-8.36-7.65-8.72-1.25-.42-3.66,5.71-5,9.43A35.67,35.67,0,0,0,231.15,342.28Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.37,301.71l-.12-.45a6.54,6.54,0,1,0-12.65,3.29l.16.61a64.09,64.09,0,0,0,7.6,17.27l11.91-5.67A49.83,49.83,0,0,1,203.37,301.71Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.91,330.21a33.72,33.72,0,0,0,2.54-3.34c-3.78-1.29-9.44-3.07-11.54-2.88-2.49.23.89,8.23,2.63,12A36.76,36.76,0,0,0,257.91,330.21Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.12,308.84c-.4.8,4.49,4.36,7.79,6.65a75.33,75.33,0,0,0,2.52-9.52C264.43,306.77,258.51,308.06,258.12,308.84Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.05,294.05c.22-2.85.33-5.57.34-8.07-3.44,1.89-7.52,4.51-7.52,6.23S266.69,294.14,270.05,294.05Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.21,216.68s-9.71,28.12-4.48,50a42.77,42.77,0,0,0,24.39,29.11s-14.19,5-11,12.69,15.42,2.74,19.41.25,9-9.95,9.7-14.93a35.73,35.73,0,0,0,.5-7.71s16.17-1.74,27.12-10.7c0,0,9.71,7.71,16.68,6.22s16.92-13.94,15.92-25.13S307,245.3,303.06,247a16,16,0,0,0-5.48,3.48s5.72-7,0-16.67a21.75,21.75,0,0,0-15.93-10.45s-3-15.93-11.94-21.9S228.9,189.31,216.21,216.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.14,226.35a56.4,56.4,0,0,1-43.86,27.22c-19.8,1.74-30.9-2.16-36-4.87a127,127,0,0,1,6-32c12.69-27.37,44.54-21.15,53.5-15.18s11.94,21.9,11.94,21.9A21.38,21.38,0,0,1,290.14,226.35ZM303.06,247a16,16,0,0,0-5.48,3.48,13.06,13.06,0,0,0,2.33-5.64c-13.45,6.7-12.4,21-14.07,21-2.06,0-3.08-7.19-3.08-7.19s-2.57,10.27-18,17.47-32.88,1.54-32.88,1.54,3.6,8.22-5.65,7.19a15.27,15.27,0,0,1-7.23-2.64,42.82,42.82,0,0,0,17.1,13.54s-14.19,5-11,12.69,15.43,2.74,19.41.25,9-9.95,9.7-14.93a35.73,35.73,0,0,0,.5-7.71s16.17-1.74,27.12-10.7c0,0,9.71,7.71,16.68,6.22s16.92-13.94,15.92-25.13S307,245.3,303.06,247Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.14,226.35a56.4,56.4,0,0,1-43.86,27.22c-19.8,1.74-30.9-2.16-36-4.87a127,127,0,0,1,6-32c12.69-27.37,44.54-21.15,53.5-15.18s11.94,21.9,11.94,21.9A21.38,21.38,0,0,1,290.14,226.35ZM303.06,247a16,16,0,0,0-5.48,3.48,13.06,13.06,0,0,0,2.33-5.64c-13.45,6.7-12.4,21-14.07,21-2.06,0-3.08-7.19-3.08-7.19s-2.57,10.27-18,17.47-32.88,1.54-32.88,1.54,3.6,8.22-5.65,7.19a15.27,15.27,0,0,1-7.23-2.64,42.82,42.82,0,0,0,17.1,13.54s-14.19,5-11,12.69,15.43,2.74,19.41.25,9-9.95,9.7-14.93a35.73,35.73,0,0,0,.5-7.71s16.17-1.74,27.12-10.7c0,0,9.71,7.71,16.68,6.22s16.92-13.94,15.92-25.13S307,245.3,303.06,247Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.78,286.11a35.12,35.12,0,0,1-28.15-12.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.21,216.68s-9.71,28.12-4.48,50a42.77,42.77,0,0,0,24.39,29.11s-14.19,5-11,12.69,15.42,2.74,19.41.25,9-9.95,9.7-14.93a35.73,35.73,0,0,0,.5-7.71s16.17-1.74,27.12-10.7c0,0,9.71,7.71,16.68,6.22s16.92-13.94,15.92-25.13S307,245.3,303.06,247a16,16,0,0,0-5.48,3.48s5.72-7,0-16.67a21.75,21.75,0,0,0-15.93-10.45s-3-15.93-11.94-21.9S228.9,189.31,216.21,216.68Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.58,250.52s-5.22,3.49-7.71,14.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.17,255.1c-.61,1.82-2.28,2.91-3.72,2.42s-2.1-2.36-1.49-4.18,2.28-2.91,3.72-2.42S307.79,253.28,307.17,255.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.32,258.34c-.61,1.82-2.28,2.91-3.72,2.42s-2.11-2.36-1.49-4.18,2.28-2.91,3.72-2.42S312.94,256.52,312.32,258.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.42,263.19a2.06,2.06,0,1,1-1.09-3A2.32,2.32,0,0,1,313.42,263.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.85,269.85c-1.8,3.25-5.4,4.69-8.05,3.22s-3.33-5.28-1.53-8.53,5.4-4.69,8.05-3.22S308.65,266.6,306.85,269.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.12,295.81a15,15,0,0,0,10.7.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.17,308.5s1-4.23,7.21-7.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.39,312.24s2.49-6,6.72-8.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.26,243.4a8.58,8.58,0,0,1-3.22-7.09V212.6H68.88a10.37,10.37,0,0,1-8-3.32,11.2,11.2,0,0,1-3.06-7.84,11.92,11.92,0,0,1,2-6.65l58.58-92.06Q125,92.54,135.94,92.54a15.68,15.68,0,0,1,10.73,3.76q4.29,3.75,4.29,11.15v89.49h15.56a7.34,7.34,0,0,1,5.79,2.3,8.52,8.52,0,0,1,0,11.06,7.34,7.34,0,0,1-5.79,2.3H150.85v23.71a8.69,8.69,0,0,1-3.11,7.09,11,11,0,0,1-7.19,2.57A11.37,11.37,0,0,1,133.26,243.4ZM130,196.94v-82.4l-51.29,82.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.13,243.88a42.42,42.42,0,0,1-15.51-11.59,60,60,0,0,1-9.76-17.65,102.32,102.32,0,0,1-5.31-21.35,176.84,176.84,0,0,1-1.5-23.93q0-79.07,54-79.07t53.87,79.07a182.94,182.94,0,0,1-1.45,23.82,100.22,100.22,0,0,1-5.26,21.35,60,60,0,0,1-9.76,17.65,42.86,42.86,0,0,1-15.51,11.64,51.64,51.64,0,0,1-21.89,4.4A52.24,52.24,0,0,1,218.13,243.88Zm32.56-15.13a25.29,25.29,0,0,0,8.05-5.47,31.76,31.76,0,0,0,5.68-8.42,59.86,59.86,0,0,0,3.81-10.2,83.39,83.39,0,0,0,2.2-11.64q.81-6.5,1.08-11.91t.26-11.75q0-6.65-.26-12.28T270.38,145a91.61,91.61,0,0,0-2.25-11.64,56.58,56.58,0,0,0-3.81-10.08,31.36,31.36,0,0,0-5.69-8.27,24.49,24.49,0,0,0-8-5.31,29.5,29.5,0,0,0-21.25,0,24.2,24.2,0,0,0-7.94,5.26,32,32,0,0,0-5.68,8.21A51,51,0,0,0,212,133.2a95.39,95.39,0,0,0-2.2,11.7q-.87,6.54-1.13,12.18t-.27,12.28q0,6.33.27,11.8t1.07,12a84.87,84.87,0,0,0,2.2,11.64A59.76,59.76,0,0,0,215.71,215a31.49,31.49,0,0,0,5.63,8.37,24.87,24.87,0,0,0,8,5.42,28.31,28.31,0,0,0,21.35,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.58,243.4a8.58,8.58,0,0,1-3.22-7.09V212.6H322.2a10.37,10.37,0,0,1-8-3.32,11.2,11.2,0,0,1-3.06-7.84,11.92,11.92,0,0,1,2-6.65l58.58-92.06q6.54-10.19,17.49-10.19A15.68,15.68,0,0,1,400,96.3q4.29,3.75,4.29,11.15v89.49h15.56a7.34,7.34,0,0,1,5.79,2.3,8.52,8.52,0,0,1,0,11.06,7.34,7.34,0,0,1-5.79,2.3H404.17v23.71a8.69,8.69,0,0,1-3.11,7.09,11,11,0,0,1-7.19,2.57A11.37,11.37,0,0,1,386.58,243.4Zm-3.22-46.46v-82.4l-51.29,82.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.05,202.5s-10.45,14.68-11.94,29.61.25,24.88,4.73,28.62,8.95,2.24,11.44-1.25-1.49-15.68-1.49-15.68,4.23-11.69,10.7-19.9,7.71-9.46,7.71-9.46S206,201.75,196.05,202.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.05,202.5A80.76,80.76,0,0,0,190,213.08c5,2,12.75,6.1,17.67,13.36.6-.87,1.22-1.73,1.86-2.54,6.47-8.21,7.71-9.46,7.71-9.46S206,201.75,196.05,202.5Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.05,202.5A80.76,80.76,0,0,0,190,213.08c5,2,12.75,6.1,17.67,13.36.6-.87,1.22-1.73,1.86-2.54,6.47-8.21,7.71-9.46,7.71-9.46S206,201.75,196.05,202.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.05,202.5s-10.45,14.68-11.94,29.61.25,24.88,4.73,28.62,8.95,2.24,11.44-1.25-1.49-15.68-1.49-15.68,4.23-11.69,10.7-19.9,7.71-9.46,7.71-9.46S206,201.75,196.05,202.5Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.84,260.73a27.63,27.63,0,0,1-1.75-10.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.55,262.22s-2.48-4.23-2.73-11.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.29,229.12c0-2.62-5-7.74-11.95-10a59,59,0,0,0-2.31,7.47,29.33,29.33,0,0,1,7.79,2.49C196.55,231.11,199.29,232.11,199.29,229.12Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.44,203.39A84.08,84.08,0,0,0,191,211a23.92,23.92,0,0,1,6,2.5c7.71,4.47,9.2,5,6.72-1.5C202.22,207.92,198.64,205.15,195.44,203.39Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.9,195.25s11.84,13.58,14.79,28.3,2.2,24.79-1.9,28.94-8.69,3.11-11.51-.12,0-15.74,0-15.74-5.36-11.23-12.6-18.77-8.61-8.65-8.61-8.65S267.92,195.48,277.9,195.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.9,195.25c-10,.23-19.88,14-19.88,14s1.36,1.12,8.61,8.65a53.06,53.06,0,0,1,3.82,4.5,42.15,42.15,0,0,1,15.67-15.3A81.53,81.53,0,0,0,277.9,195.25Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.9,195.25c-10,.23-19.88,14-19.88,14s1.36,1.12,8.61,8.65a53.06,53.06,0,0,1,3.82,4.5,42.15,42.15,0,0,1,15.67-15.3A81.53,81.53,0,0,0,277.9,195.25Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.9,195.25s11.84,13.58,14.79,28.3,2.2,24.79-1.9,28.94-8.69,3.11-11.51-.12,0-15.74,0-15.74-5.36-11.23-12.6-18.77-8.61-8.65-8.61-8.65S267.92,195.48,277.9,195.25Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.79,252.49a27.54,27.54,0,0,0,.74-10.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.25,254.63s2.07-4.45,1.61-11.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.29,222.06c-.25-2.61,4.22-8.19,10.92-11.08a58.59,58.59,0,0,1,3,7.2,29.93,29.93,0,0,0-7.5,3.25C280.21,223.78,277.59,225,277.29,222.06Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.59,196.08a81.4,81.4,0,0,1,5.14,7.09,24.07,24.07,0,0,0-5.75,3.07c-7.23,5.22-8.67,5.86-6.83-.82C272.3,201.25,275.58,198.14,278.59,196.08Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.07,189.8s-3.08,10.39-1.92,14.62,6.54.39,11.93,5,10.38,12.93,30.79,14.47,32.73-9.47,37-15.63,3.85-13.47,11.16-13.85,1.16-14.63-1.15-16.94c0,0,14.24-21.17,14.24-26.56s-13.47-4.24-30,.77c0,0-12.32-6.55-34.65-2.7s-28.87,10.4-28.87,10.4-27.72,3.46-29.64,6.92S177.75,184.41,195.07,189.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284,194.42c7.32-.39,1.16-14.63-1.15-16.94,0,0,2.71-4,5.76-9-8.27-4.32-16.39-6.72-18.55-4.29-4.65,5.22-2.12,15.22,0,25s-6.35,13.95-12.27,22.41-14.37-.85-14.37-.85c-3,12.27-15.65,4.23-15.65,4.23-9.72-3-26.21-12.68-22.83-19.45s4.23-13.11-1.69-18.6-29.53-10.06-29.53-10.06h0c-1.24,4.17,4.75,17.83,21.36,23,0,0-3.08,10.39-1.92,14.62s6.54.39,11.93,5,10.38,12.93,30.79,14.47,32.73-9.47,37-15.63S276.68,194.8,284,194.42Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,194.42c7.32-.39,1.16-14.63-1.15-16.94,0,0,2.71-4,5.76-9-8.27-4.32-16.39-6.72-18.55-4.29-4.65,5.22-2.12,15.22,0,25s-6.35,13.95-12.27,22.41-14.37-.85-14.37-.85c-3,12.27-15.65,4.23-15.65,4.23-9.72-3-26.21-12.68-22.83-19.45s4.23-13.11-1.69-18.6-29.53-10.06-29.53-10.06h0c-1.24,4.17,4.75,17.83,21.36,23,0,0-3.08,10.39-1.92,14.62s6.54.39,11.93,5,10.38,12.93,30.79,14.47,32.73-9.47,37-15.63S276.68,194.8,284,194.42Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.89,196.74c.29,2.44-5.13,5.07-12.08,5.88s-12.83-.51-13.12-3,5.13-5.06,12.09-5.87S253.61,194.31,253.89,196.74Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.89,196.74c.29,2.44-5.13,5.07-12.08,5.88s-12.83-.51-13.12-3,5.13-5.06,12.09-5.87S253.61,194.31,253.89,196.74Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.07,189.8s-3.08,10.39-1.92,14.62,6.54.39,11.93,5,10.38,12.93,30.79,14.47,32.73-9.47,37-15.63,3.85-13.47,11.16-13.85,1.16-14.63-1.15-16.94c0,0,14.24-21.17,14.24-26.56s-13.47-4.24-30,.77c0,0-12.32-6.55-34.65-2.7s-28.87,10.4-28.87,10.4-27.72,3.46-29.64,6.92S177.75,184.41,195.07,189.8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.69,159c-10,6.72-6.47,13.44-2,17.17,2.73,2.28,7.13,2,10.14,1.36h0s14.24-21.17,14.24-26.56C297.08,150.92,284.64,152.23,274.69,159Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.71,166.8c-1.24,4.17,4.75,17.83,21.36,23,0,0,12.68-1.24,8.45-11.44C199.57,168.84,179.6,166.47,173.71,166.8Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.41,149c-1.31.23-2.57.47-3.78.71,2,10.1,5.29,26.92,8.23,26.92s5.19-18.44,6.15-28.77A82,82,0,0,0,232.41,149Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.94,173.63c3.06-1.8,2.6-15.33,2.11-22.67a82.12,82.12,0,0,0-9.31,2.91C214.85,160.74,217.67,175.55,220.94,173.63Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.55,167.41c3.13,1.1,4.89-10.15,5.88-18.81a62.32,62.32,0,0,0-9.56-.81C246.77,154.9,247.16,166.22,250.55,167.41Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.36,206.35a11.78,11.78,0,0,0-8.67,1.07.86.86,0,0,0-.16,1.37l5.31,5a.86.86,0,0,0,1.37-.27l2.72-6A.86.86,0,0,0,246.36,206.35Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.74,198c.73,1.93.44,3.83-.65,4.24s-2.57-.81-3.31-2.73-.44-3.83.65-4.24S233,196.08,233.74,198Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.22,196.63c-.38,2,.24,3.85,1.39,4.06s2.39-1.25,2.77-3.28-.24-3.84-1.39-4.06S248.6,194.61,248.22,196.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.21,213.51s-7.1,9.64-13.57-.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.84,213.78s4.72,4.89,9.7,2.15,2-7,2-7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.19,190.3s1.74-6.22,9.95-4.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3399120569229126px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.07,184.58s6.22-3.73,11.94,2.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.3399120569229126px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.46,
    y1: 206.98,
    x2: 222.43,
    y2: 208.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.68,
    y1: 210.71,
    x2: 216.46,
    y2: 211.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.68,
    y1: 213.45,
    x2: 218.95,
    y2: 215.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.5,
    y1: 204.24,
    x2: 265.73,
    y2: 202.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.5,
    y1: 206.73,
    x2: 264.98,
    y2: 206.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 262.24,
    y1: 209.22,
    x2: 266.97,
    y2: 210.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1133040189743042px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4041);
export default __webpack_public_path__ + "static/media/404(1).892097fce26392e6a2be7404d9e4a3de.svg";
export { ForwardRef as ReactComponent };